import { createSlice } from '@reduxjs/toolkit';


interface userPermisssionState {
    client:any;
    env:any;
    IsUserPermissionConfigured:any;
    userPermissions:Array<{}>
  }
const initialState: userPermisssionState = {
    client:'',
    env:'',
    IsUserPermissionConfigured:false,
    userPermissions:[]
    
};
export const userPermisssion = createSlice({
  name: 'userPermisssion',
  initialState: initialState,
  reducers: {
    setClient: (state,action:any) => { 
        state.client=action.payload;
      },
    setEnv: (state,action:any) => { 
        state.env=action.payload;
      },
    setUserPermissions: (state,action:any) => { 
        state.userPermissions=action.payload;
      },
    setIsUserPermissionConfigured: (state,action:any) => { 
        state.IsUserPermissionConfigured=action.payload;
      }
    }
});

// this is for dispatch
export const { setClient, setEnv,setIsUserPermissionConfigured,setUserPermissions } = userPermisssion.actions;

// this is for configureStore
export default userPermisssion.reducer;